var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-container",attrs:{"id":"join-test-main"}},[_c('button',{staticClass:"btn btn-primary btn-login"},[_vm._v("login-test")])])
}]

export { render, staticRenderFns }